/* osyn-platforms.js — Section « Jouez à tout, partout. » -------------------------------
 * Reveals Apple (IO), teinte de l'aura pilotée par le chapitre actif, parallaxe du phone,
 * vidéo lazy (play/pause selon visibilité), centrage sticky (header + hauteur mesurés).
 * Listeners au niveau module (aucune fuite à la ré-init éditeur). Respecte reduced-motion.
 * -------------------------------------------------------------------------------------- */
(function () {
  'use strict';

  var MQ_DESKTOP = '(min-width: 1024px)';
  var REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sections = [];          // sections actives (pour scroll/resize partagés)
  var raf = null;

  function measureHeader() {
    var h = document.querySelector('.shopify-section-group-header-group .header, .header');
    return h ? Math.round(h.getBoundingClientRect().height) : 0;
  }

  function setVars(root) {
    root.style.setProperty('--pf-header-h', measureHeader() + 'px');
    var stage = root.querySelector('[data-osyn-pf-stage]');
    if (stage) root.style.setProperty('--pf-stage-h', Math.round(stage.getBoundingClientRect().height) + 'px');
    // rayon de l'écran en PX (égal sur les 2 axes = coins circulaires) ∝ hauteur rendue
    var screen = root.querySelector('.osyn-pf__screen');
    if (screen) {
      var ratio = parseFloat(getComputedStyle(root).getPropertyValue('--scr-rr')) || 0.16;
      root.style.setProperty('--scr-r', (screen.getBoundingClientRect().height * ratio).toFixed(1) + 'px');
    }
  }

  function updateParallax() {
    raf = null;
    var desktop = matchMedia(MQ_DESKTOP).matches;
    var vh = window.innerHeight;
    sections.forEach(function (root) {
      if (!root.isConnected) return;
      var phone = root._pfPhone;
      if (!phone) return;
      if (!desktop) { phone.style.removeProperty('--pf-parallax'); return; }
      var r = root.getBoundingClientRect();
      var p = (vh - r.top) / (vh + r.height);          // 0 (entre en bas) → 1 (sort en haut)
      p = p < 0 ? 0 : (p > 1 ? 1 : p);
      phone.style.setProperty('--pf-parallax', ((p - 0.5) * 60).toFixed(1) + 'px');   // ±30px
    });
  }
  function onScroll() { if (raf == null) raf = requestAnimationFrame(updateParallax); }
  function onResize() { sections.forEach(function (r) { if (r.isConnected) setVars(r); }); onScroll(); }

  function initSection(root) {
    if (!root || root._pfInit) return;
    root._pfInit = true;
    root._pfPhone = root.querySelector('.osyn-pf__phone');
    sections.push(root);
    setVars(root);
    root.classList.add('is-ready');

    if (REDUCED) return;       // tout visible via CSS ; pas d'anim, vidéo en poster

    var stage = root.querySelector('[data-osyn-pf-stage]');
    var modes = [].slice.call(root.querySelectorAll('[data-osyn-pf-mode]'));
    var video = root.querySelector('[data-osyn-pf-video]');

    // reveals (one-shot)
    var revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); } });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
    if (stage) revealIO.observe(stage);
    modes.forEach(function (m) { revealIO.observe(m); });

    // dégradé/teinte de marque = chapitre le plus présent au centre (data-grad → data-active)
    var tintIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && e.intersectionRatio >= 0.5) {
          var g = e.target.getAttribute('data-grad');
          if (g) root.dataset.active = g;
        }
      });
    }, { threshold: [0.5], rootMargin: '-20% 0px -20% 0px' });
    modes.forEach(function (m) { tintIO.observe(m); });

    // vidéo lazy : joue quand visible, pause sinon
    if (video) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { var pr = video.play(); if (pr && pr.catch) pr.catch(function () {}); }
          else { video.pause(); }
        });
      }, { threshold: 0.2 });
      vio.observe(video);
    }
  }

  /* masquée sur mobile (réglage « Affichage ») : aucune boîte → aucun observateur ni vidéo ;
     initialisée quand elle devient visible (rotation de tablette, redimensionnement) */
  function initAll() {
    [].slice.call(document.querySelectorAll('[data-osyn-platforms]')).forEach(function (root) {
      if (root.getClientRects().length) initSection(root);
    });
  }
  matchMedia(MQ_DESKTOP).addEventListener('change', function () { initAll(); onResize(); });

  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onResize);
  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', function () { initAll(); onScroll(); });
  else { initAll(); onScroll(); }

  // éditeur de thème : ré-init propre (le DOM est remplacé → nouvel élément)
  document.addEventListener('shopify:section:load', function (e) {
    sections = sections.filter(function (r) { return r.isConnected; });
    var el = e.target && e.target.querySelector && e.target.querySelector('[data-osyn-platforms]');
    if (el) { initSection(el); onScroll(); }
  });
})();
